export default function createActionWithAppend(type, withAuth = true) {
	return (payload, append = false) => ({
		type,
		payload,
		append,
		withAuth,
	});
}
